import { Injectable } from '@angular/core';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  constructor(private authService: AuthService) { }

  get isSolicitanRefacturacion(): boolean {
    return this.authService.hasRole(
      TipoUsuario.SUPERVISOR, 
      TipoUsuario.TUTOR, 
      TipoUsuario.OPERADOR, 
      TipoUsuario.OPERADOR_3, 
      TipoUsuario.OPERADORDIRECTO, 
      TipoUsuario.COMERCIAL_LN, 
      TipoUsuario.COMERCIAL_AV)
  }

}